// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.helpterm[data-v-786b3090]{padding:2px 6px;border-radius:4px;font-family:Roboto,sans-serif;color:#0d0f11;background-color:#fcf1c4}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
